import requestActionFactory from '../../utils/requestActionsFactory';
import { ActionTemplate } from '../../../typings';

export const SET_OFFER = 'SET_OFFER';
export const SET_ADDRESS_VALUE = 'SET_ADDRESS_VALUE';
export const SET_INITIAL_ADDRESS_VALUE = 'SET_INITIAL_ADDRESS_VALUE';
export const SET_SHOULD_SAVE_DATA = 'SET_SHOULD_SAVE_DATA';
export const SET_LOADING = 'SET_LOADING';
export const SET_CONFIRMING = 'SET_CONFIRMING';
export const CHECK_VALIDATION = 'CHECK_VALIDATION';
export const SET_DIRTY = 'SET_DIRTY';
export const CLEAR_ORDER_ERRORS = 'CLEAR_ORDER_ERRORS';
export const SET_PAYU_DETAILS_VALUE = 'SET_PAYU_DETAILS_VALUE';
export const SET_REQUEST_INVOICE = 'SET_REQUEST_INVOICE';
export const SET_REQUEST_INVOICE_TYPE = 'SET_REQUEST_INVOICE_TYPE';
export const SET_REQUEST_INVOICE_VALUE = 'SET_REQUEST_INVOICE_VALUE';
export const SET_ADDRESS_DATA_TO_REQUEST_INVOICE_FORM = 'SET_ADDRESS_DATA_TO_REQUEST_INVOICE_FORM';
export const TOGGLE_USE_DELIVERY_DETAILS_FOR_INVOICE_FORM =
  'TOGGLE_USE_DELIVERY_DETAILS_FOR_INVOICE_FORM';
export const UNSET_USE_DELIVERY_DETAILS_FOR_INVOICE_FORM =
  'UNSET_USE_DELIVERY_DETAILS_FOR_INVOICE_FORM';

export const [ATLAS_AD_LOAD, ATLAS_AD_SUCCESS, ATLAS_AD_ERROR] = requestActionFactory(
  type => `ATLAS_AD_${type}`,
);

export const [USER_CONTACT_LOAD, USER_CONTACT_SUCCESS, USER_CONTACT_ERROR] = requestActionFactory(
  type => `USER_CONTACT_${type}`,
);

export const [
  PREPOPULATED_DATA_LOAD,
  PREPOPULATED_DATA_SUCCESS,
  PREPOPULATED_DATA_ERROR,
  SET_PREPOPULATED_DATA_CONSENT_CHECKED,
  SET_PREPOPULATED_DATA_IS_LEGACY, // TODO: DO-3088 Clean Up - Legacy Prefill
  DISPLAY_PREPOPULATED_DATA, // TODO: DO-3088 Clean Up - Legacy Prefill
  CLEAR_PREPOPULATED_DATA,
  PREFILL_PREPOPULATED_DATA,
] = [
  ...requestActionFactory(type => `PREPOPULATED_DATA_${type}`),
  'SET_PREPOPULATED_DATA_CONSENT_CHECKED',
  'SET_PREPOPULATED_DATA_IS_LEGACY', // TODO: DO-3088 Clean Up - Legacy Prefill
  'DISPLAY_PREPOPULATED_DATA', // TODO: DO-3088 Clean Up - Legacy Prefill
  'CLEAR_PREPOPULATED_DATA',
  'PREFILL_PREPOPULATED_DATA',
];

export const [SERVICE_POINTS_LOAD, SERVICE_POINTS_SUCCESS, SERVICE_POINTS_ERROR] =
  requestActionFactory(type => `SERVICE_POINTS_${type}`);

export const [NEARBY_SERVICE_POINTS_SUCCESS, NEARBY_SERVICE_POINTS_ERROR] = requestActionFactory(
  type => `NEARBY_SERVICE_POINTS_${type}`,
);

export const [CURRENT_SERVICE_POINTS_SELECT] = requestActionFactory(
  type => `CURRENT_SERVICE_POINTS${type}`,
);

export const [SHIPMENT_METHODS_LOAD, SHIPMENT_METHODS_SUCCESS, SHIPMENT_METHODS_ERROR] =
  requestActionFactory(type => `SHIPMENT_METHODS_${type}`);

export const [POST_ORDER_LOAD, POST_ORDER_SUCCESS, POST_ORDER_ERROR] = requestActionFactory(
  type => `POST_ORDER_${type}`,
);
export const POST_ORDER_ERROR_ = (key: string | TemplateStringsArray): string =>
  `POST_ORDER_ERROR_${key}`;

export const POST_ORDER_ERROR_SELLER_ACCOUNT_CREATION_PENDING = POST_ORDER_ERROR_`SELLER_ACCOUNT_CREATION_PENDING`;
export const POST_ORDER_ERROR_SELLER_ACCOUNT_BLOCKED = POST_ORDER_ERROR_`SELLER_ACCOUNT_BLOCKED`;
export const POST_ORDER_ERROR_PAYMENT_ALREADY_EXISTS = POST_ORDER_ERROR_`PAYMENT_ALREADY_EXISTS`;
export const POST_ORDER_ERROR_PAYMENT_METHOD_NOT_SUPPORTED = POST_ORDER_ERROR_`PAYMENT_METHOD_NOT_SUPPORTED`;
export const POST_ORDER_ERROR_AD_STATUS_CHANGED = POST_ORDER_ERROR_`AD_STATUS_CHANGED`;
export const POST_ORDER_ERROR_OFFER_ALREADY_ORDERED = POST_ORDER_ERROR_`OFFER_ALREADY_ORDERED`;

export const POST_ORDER_ERROR_INVALID_FORMAT = POST_ORDER_ERROR_`INVALID_FORMAT`;
export const POST_ORDER_ERROR_NOT_EMPTY = POST_ORDER_ERROR_`NOT_EMPTY`;
export const POST_ORDER_ERROR_MAX_LENGTH = POST_ORDER_ERROR_`MAX_LENGTH`;
export const POST_ORDER_ERROR_MIN_LENGTH = POST_ORDER_ERROR_`MIN_LENGTH`;
export const POST_ORDER_ERROR_POSTCODE_NOT_SUPPORTED = POST_ORDER_ERROR_`POSTCODE_NOT_SUPPORTED`;
export const POST_ORDER_ERROR_INVALID_ISO_COUNTRY_CODE = POST_ORDER_ERROR_`INVALID_ISO_COUNTRY_CODE`;

export const POST_CONTRACT_ERROR_ = (key: string | TemplateStringsArray): string =>
  `POST_CONTRACT_VALIDATION_ERROR_${key}`;

export const POST_CONTRACT_ERROR_POSTCODE_NOT_SUPPORTED = POST_CONTRACT_ERROR_`POSTCODE_NOT_SUPPORTED`;
export const POST_CONTRACT_ERROR_ORDER_NOT_FOUND = POST_CONTRACT_ERROR_`ORDER_NOT_FOUND`;
export const POST_CONTRACT_ERROR_OFFER_DOES_NOT_BELONG_TO_SELLER = POST_CONTRACT_ERROR_`OFFER_DOES_NOT_BELONG_TO_SELLER`;
export const POST_CONTRACT_ERROR_ORDER_IS_NOT_ACTIVE = POST_CONTRACT_ERROR_`ORDER_IS_NOT_ACTIVE`;
export const POST_CONTRACT_ERROR_ADDRESS_DOES_NOT_BELONG_TO_SELLER = POST_CONTRACT_ERROR_`ADDRESS_DOES_NOT_BELONG_TO_SELLER`;
export const POST_CONTRACT_ERROR_ORDER_ALREADY_HAS_CONTRACT = POST_CONTRACT_ERROR_`ORDER_ALREADY_HAS_CONTRACT`;
export const POST_CONTRACT_ERROR_INVALID_FORMAT = POST_CONTRACT_ERROR_`INVALID_FORMAT`;
export const POST_CONTRACT_ERROR_NOT_EMPTY = POST_CONTRACT_ERROR_`NOT_EMPTY`;
export const POST_CONTRACT_ERROR_MAX_LENGTH = POST_CONTRACT_ERROR_`MAX_LENGTH`;

export const POST_BILLING_ERROR_ = (key: string | TemplateStringsArray): string =>
  `POST_BILLING_VALIDATION_ERROR_${key}`;

export const POST_BILLING_ERROR_POSTCODE_NOT_SUPPORTED = POST_BILLING_ERROR_`POSTCODE_NOT_SUPPORTED`;
export const POST_BILLING_ERROR_INVALID_FORMAT = POST_BILLING_ERROR_`INVALID_FORMAT`;
export const POST_BILLING_ERROR_NOT_EMPTY = POST_BILLING_ERROR_`NOT_EMPTY`;
export const POST_BILLING_ERROR_MAX_LENGTH = POST_BILLING_ERROR_`MAX_LENGTH`;
export const POST_BILLING_ERROR_INVALID_ISO_COUNTRY_CODE = POST_BILLING_ERROR_`INVALID_ISO_COUNTRY_CODE`;

const SERVICE_POINT_: ActionTemplate = type => `SERVICE_POINT_${type}`;

export const [SERVICE_POINT_LOAD, SERVICE_POINT_SUCCESS, SERVICE_POINT_ERROR] =
  requestActionFactory(SERVICE_POINT_);

const PRICE_PREVIEW_: ActionTemplate = type => `PRICE_PREVIEW_${type}`;

export const [PRICE_PREVIEW_LOAD, PRICE_PREVIEW_SUCCESS, PRICE_PREVIEW_ERROR] =
  requestActionFactory(PRICE_PREVIEW_);

export const SERVICE_POINT_SELECT = SERVICE_POINT_`SELECT`;

export const [POST_CONTRACT_LOAD, POST_CONTRACT_SUCCESS, POST_CONTRACT_ERROR] =
  requestActionFactory(type => `POST_CONTRACT_${type}`);

export const [OPERATORS_LOAD, OPERATORS_SUCCESS, OPERATORS_ERROR] = requestActionFactory(
  type => `OPERATORS_${type}`,
);

export const SET_CURRENT_OPERATOR = 'SET_CURRENT_OPERATOR';
export const SET_DONATION_PRICE = 'SET_DONATION_PRICE';

export const ATLAS_COUNTRIES_LOAD = 'ATLAS_COUNTRIES_LOAD';
export const ATLAS_COUNTRIES_SUCCESS = 'ATLAS_COUNTRIES_SUCCESS';
export const ATLAS_COUNTRIES_ERROR = 'ATLAS_COUNTRIES_ERROR';

export const GET_SELLER_DETAILS = 'GET_SELLER_DETAILS';
export const LOADING_SELLER_DETAILS = 'LOADING_SELLER_DETAILS';

export const SET_KEEP_OLX_DELIVERY = 'SET_KEEP_OLX_DELIVERY';

export const LOYALTY_POINTS_OPT_IN_STATUS_LOAD = 'LOYALTY_POINTS_OPT_IN_STATUS_LOAD';
export const LOYALTY_POINTS_OPT_IN_STATUS_SUCCESS = 'LOYALTY_POINTS_OPT_IN_STATUS_SUCCESS';
export const LOYALTY_POINTS_OPT_IN_STATUS_ERROR = 'LOYALTY_POINTS_OPT_IN_STATUS_ERROR';
export const LOYALTY_POINTS_FLAG_HUB_VISIBLE_LOAD = 'LOYALTY_POINTS_FLAG_HUB_VISIBLE_LOAD';
export const LOYALTY_POINTS_FLAG_HUB_VISIBLE_SUCCESS = 'LOYALTY_POINTS_FLAG_HUB_VISIBLE_SUCCESS';
export const LOYALTY_POINTS_FLAG_HUB_VISIBLE_ERROR = 'LOYALTY_POINTS_FLAG_HUB_VISIBLE_ERROR';
export const LOYALTY_POINTS_PREVIEW_POINTS_LOAD = 'LOYALTY_POINTS_PREVIEW_POINTS_LOAD';
export const LOYALTY_POINTS_PREVIEW_POINTS_SUCCESS = 'LOYALTY_POINTS_PREVIEW_POINTS_SUCCESS';
export const LOYALTY_POINTS_PREVIEW_POINTS_ERROR = 'LOYALTY_POINTS_PREVIEW_POINTS_ERROR';
export const LOYALTY_POINTS_OPT_IN_CHECK_TOGGLE = 'LOYALTY_POINTS_OPT_IN_CHECK_TOGGLE';

export const LOYALTY_POINTS_WHITELIST_USER_LOAD = 'LOYALTY_POINTS_WHITELIST_USER_LOAD';
export const LOYALTY_POINTS_WHITELIST_USER_SUCCESS = 'LOYALTY_POINTS_WHITELIST_USER_SUCCESS';
export const LOYALTY_POINTS_WHITELIST_USER_ERROR = 'LOYALTY_POINTS_WHITELIST_USER_ERROR';
